module.exports = __webpack_public_path__ + "static/media/account-blue.3dad833b.svg";